module.exports = __webpack_public_path__ + "static/media/cave.d4a5254a.png";